import { message as $message } from 'antd'
import { imageUrlValidatorParam, validatorImageList, clean } from '@/components/Uploader/helper'
import { ERROR_TYPE } from '@/components/Uploader/constants'
import { FIELD_GOODS_SKU, FIELD_GOODS_SKUDETAIL } from '@/modules/globals/constants/platform/fieldNames'
import { imageResize, imageZoomUsingPOST } from '@/services/goods'

import uniqBy from 'lodash/uniqBy'
import omit from 'lodash/omit'
import repairUrlData from './repairUrlData'

export const REPLACE_IMAGE_RECT_RATIO = 'rectRatio'
export const REPLACE_IMAGE_SIZE = 'size'

export const transImagesErrors = ({ value, singleValidate }) => {
    const validatorParam = imageUrlValidatorParam(singleValidate)
    const cleanList = Array.isArray(value) ? clean(value) || [] : [value]

    const { errorList } = validatorImageList({
        cleanList,
        value,
        validatorParam: omit(validatorParam, ['validatorNum'])
    })

    return errorList
}

export const transReplaceErrors = (imagesErrors, validate) => {
    const rectRatioErrorList = []
    const sizeErrorList = []

    const onlyPNG =
        validate?.imageTypeValidator?.acceptTypeList?.length === 1 &&
        validate.imageTypeValidator.acceptTypeList[0] === 'image/png'

    const validatorParam = imageUrlValidatorParam(validate)

    for (let index = 0; index < imagesErrors.length; index++) {
        const item = imagesErrors[index]
        if (item.type === ERROR_TYPE.RECT || item.type === ERROR_TYPE.RATIO) {
            rectRatioErrorList.push(item)
        } else if (!onlyPNG && validatorParam?.sizeValidator?.maxSize < 20 && item.type === ERROR_TYPE.SIZE) {
            sizeErrorList.push(item)
        }
    }
    return {
        [REPLACE_IMAGE_RECT_RATIO]: rectRatioErrorList,
        [REPLACE_IMAGE_SIZE]: sizeErrorList
    }
}

export const transRectRatioReplaceImages = ({ singleValidate, name, replaceErrors }) => {
    const validatorParam = imageUrlValidatorParam(singleValidate)
    const mergeErrors = uniqBy(replaceErrors, 'url')

    return mergeErrors.map(item => {
        return {
            ...repairUrlData({
                url: item.url,
                validatorParam
            }),
            name
        }
    })
}

export const transSizeReplaceImages = ({ singleValidate, name, replaceErrors }) => {
    const validatorParam = imageUrlValidatorParam(singleValidate)
    const mergeErrors = uniqBy(replaceErrors, 'url')

    return mergeErrors
        .map(item => ({
            maxSize: (validatorParam?.sizeValidator?.maxSize || 0) * 1024 * 1024,
            url: item.url,
            name
        }))
        .filter(_ => _.maxSize)
}

export const replaceErrorImages = async ({ replaceErrors, validate, value, name }) => {
    if (replaceErrors[REPLACE_IMAGE_RECT_RATIO]?.length) {
        const replaceImages = transRectRatioReplaceImages({
            singleValidate: validate,
            replaceErrors: replaceErrors[REPLACE_IMAGE_RECT_RATIO]
        })

        const { success, data, message } = await imageResize(
            replaceImages.map(({ styleType, url }) => ({
                styleType,
                url
            }))
        )

        if (!success) {
            $message.error(message)
            return Promise.reject(Error(message))
        }
        if ([FIELD_GOODS_SKU, FIELD_GOODS_SKUDETAIL].includes(name)) {
            return data
        } else {
            const newValue = replacePicToValue({
                value,
                newPics: data
            })

            return newValue
        }
    } else if (replaceErrors[REPLACE_IMAGE_SIZE]?.length) {
        const replaceImages = transSizeReplaceImages({
            singleValidate: validate,
            replaceErrors: replaceErrors[REPLACE_IMAGE_SIZE]
        })

        const { success, data, message } = await imageZoomUsingPOST(
            replaceImages.map(({ maxSize, url }) => ({
                maxSize,
                url
            }))
        )

        if (!success) {
            $message.error(message)
            return Promise.reject(Error(message))
        }
        if (data.every(item => item.oldUrl === item.newUrl)) {
            $message.error('不支持压缩20M以上的图片')
            return Promise.reject(Error('不支持压缩20M以上的图片'))
        }
        if ([FIELD_GOODS_SKU, FIELD_GOODS_SKUDETAIL].includes(name)) {
            return data
        } else {
            const newValue = replacePicToValue({
                value,
                newPics: data
            })

            return newValue
        }
    }
}

export const replacePicToGoodsSku = ({ value: goodsSku, newPics }) => {
    return goodsSku.map(item => {
        return {
            ...item,
            value: item?.value?.map(item2 => {
                if (item2?.pic && typeof item2?.pic === 'object') {
                    const newPic = newPics?.find(item3 => item3?.oldUrl === item2?.pic?.url)

                    return {
                        ...item2,
                        pic: {
                            ...item2?.pic,
                            url: newPic?.newUrl || item2?.pic?.url
                        }
                    }
                }
                return item2
            })
        }
    })
}

export const replacePicToGoodsSkuDetail = ({ value: goodsSkuDetail, newPics }) => {
    let str = JSON.stringify(goodsSkuDetail)

    newPics.forEach(({ oldUrl, newUrl }) => {
        // 全部替换（考虑多个相同的 oldUrl 出现）
        const reg = new RegExp(oldUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
        str = str.replace(reg, newUrl)
    })

    return JSON.parse(str)
}

export const replacePicToValue = ({ value, newPics }) => {
    try {
        if (!Array.isArray(newPics)) {
            return null
        }

        if (Array.isArray(value)) {
            return value.map(item => {
                const replaceItem = newPics.find(item2 => item2?.oldUrl === item?.url)

                if (replaceItem) {
                    return {
                        ...item,
                        url: replaceItem?.newUrl
                    }
                }

                return item
            })
        } else if (typeof value === 'object') {
            const replaceItem = newPics.find(item2 => item2?.oldUrl === value?.url)
            return {
                ...value,
                url: replaceItem?.newUrl
            }
        }

        return null
    } catch (error) {
        console.error('replacePicToValue', error)
        return null
    }
}
